
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { getStateList } from "@/api/users";
import { addVariousTags, deleteVariousTags, modifyVariousTags } from "@/api/allTags";

@Component({
  name: "StaffStatus",
  components: {},
})
export default class extends Vue {
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  private activeName='first';
  private tableData=[]
  created() {
    this.getStateList()
  }
  private getStateList() {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      type: this.activeName === 'first' ? '21' : '22'
    }
    getStateList(pamars).then((res:any) => {
      if (res.data) {
        this.tableData = res.data.list
        this.pagination.total = res.data.count
      } else {
        this.tableData = []
      }
    })
  }
  private tabBeforeHandle(activeName: string, oldActiveName: string) {
    this.pagination.currentPage = 1
    this.getStateList();
  }
  private handleCurrentChange(page: number) {
    this.pagination.currentPage = page;
    this.getStateList();
  }
  private handleSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getStateList();
  }
  private addStatus() {
    this.$prompt('名称', '新增状态', {
      confirmButtonText: '完成',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入1-10个字标签名称',
      inputPattern: /^.{1,10}$/,
      inputErrorMessage: '请输入1-10个字标签名称'
    }).then(({ value }: any) => {
      this.add(value)
    }).catch(() => {});
  }
  private editHandle(val:any) {
    this.$prompt('名称', '编辑状态', {
      confirmButtonText: '完成',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入1-10个字标签名称',
      inputPattern: /^.{1,10}$/,
      inputErrorMessage: '请输入1-10个字标签名称',
      inputValue: val.name
    }).then(({ value }: any) => {
      this.edit(value, val.id)
    }).catch(() => {});
  }
  private add(name:string) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: name,
      type: this.activeName === 'first' ? '21' : '22'
    };
    addVariousTags(pamars).then((res:any) => {
      this.showSecussMsg(res.msg)
      this.getStateList()
    }).catch(err => {
      this.showErrorMsg(err.msg)
    })
  }
  private edit(name:string, id:string) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: name,
      type: this.activeName === 'first' ? '21' : '22',
      tags_id: id
    };
    modifyVariousTags(pamars).then((res:any) => {
      this.showSecussMsg(res.msg)
      this.getStateList()
    }).catch(err => {
      this.showErrorMsg(err.msg)
    })
  }
  private deleteHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          tags_id: val.id,
          type: this.activeName === 'first' ? '21' : '22'
        };
        deleteVariousTags(params)
          .then((res:any) => {
            this.pagination.currentPage = 1;
            this.getStateList();
            this.showSecussMsg(res.msg);
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
